var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsVisibilityOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "l4o1m1kjua",
    d: "M9 4.6c3.1 0 5.866 1.704 7.216 4.4-1.35 2.696-4.115 4.4-7.216 4.4-3.1 0-5.866-1.704-7.216-4.4C3.134 6.304 5.899 4.6 9 4.6M9 3C4.91 3 1.415 5.488 0 9c1.415 3.512 4.91 6 9 6s7.585-2.488 9-6c-1.415-3.512-4.91-6-9-6zm0 1.4C6.97 4.4 5.318 6.016 5.318 8S6.971 11.6 9 11.6c2.03 0 3.682-1.616 3.682-3.6S11.029 4.4 9 4.4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-740 -424) translate(442 130) translate(298 294)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#444",
    fillRule: "nonzero",
    xlinkHref: "#l4o1m1kjua"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7,
    fill: "#FFF",
    fillRule: "nonzero",
    rx: 1.5,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M0 15.761L15 0.761",
    transform: "matrix(-1 0 0 1 15 0)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeWidth: 2,
    d: "M2 15.761L17 0.761",
    transform: "matrix(-1 0 0 1 19 0)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsVisibilityOff);
export default __webpack_public_path__ + "static/media/icons-visibility-off.6fc727396935c4bd026bb7580a22191a.svg";
export { ForwardRef as ReactComponent };